// main.tsx — entry point. badges.css is imported before the app's own
// index.css so the shared badge chrome is in place before the brand overrides
// land on top of it (DESIGN.md).
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import 'common/badges.css'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
